// The review queue is oldest-first and can outgrow one page, so status, search
// and org filtering all go to the server; filtering a fetched page in the
// browser would hide every order beyond it.
const PENDING_REVIEW_FILTER = 'status:pending_review';

export const initialReviewQueueRequest = limit => ({
  offset: 0,
  limit,
  filterBy: [PENDING_REVIEW_FILTER],
});

export const withOrgFilters = (request, filters) => {
  // Same "applied filter" rule as getRelevantFilters; kept inline so this
  // module stays free of app imports.
  const orgId = (filters || [])
    .filter(filter => filter.group === 'org_uuid' && filter.state && filter.value !== 'all')
    .map(filter => filter.value);
  return { ...request, offset: 0, orgId: orgId.length ? orgId : undefined };
};

export const withSearch = (request, search) => ({ ...request, offset: 0, search: search || undefined });

export const withOffset = (request, offset) => ({ ...request, offset });

export const withPageSize = (request, limit) => ({ ...request, offset: 0, limit });

// A page past the end (accepting the last row of the last page, or a page
// number typed into the pager) comes back empty; jump straight to the last
// page that exists instead of stepping back one request at a time.
export const lastExistingPage = (request, totalRecords) => ({
  ...request,
  offset: totalRecords > 0 ? Math.floor((totalRecords - 1) / request.limit) * request.limit : 0,
});

// Only the total is needed, so ask for a single row.
export const pendingReviewCountRequest = orgIds => ({
  orgId: orgIds && orgIds.length > 0 ? orgIds : undefined,
  filterBy: [PENDING_REVIEW_FILTER],
  limit: 1,
});
